<template>
  <div class="input-dirs" v-loading="loading">
    <h4>Привязка полей к работам</h4>
    <div style="margin-bottom: 80px; width: 100%">
      <div class="list-inputs">
        <div class="name-line">
          <span>План всего</span>
          <el-checkbox v-model="defaultInputs.plan" size="medium"></el-checkbox>
        </div>
      </div>
      <div class="list-inputs">
        <div class="name-line">
          <span>Суточный план</span>
          <el-checkbox v-model="defaultInputs.daily_plan" size="medium"></el-checkbox>
        </div>
      </div>
      <div class="list-inputs">
        <div class="name-line">
          <span>Суточный план норма ч/ч</span>
          <el-checkbox v-model="defaultInputs.daily_norm" size="medium"></el-checkbox>
        </div>
      </div>
      <div class="list-inputs">
        <div class="name-line">
          <span>Факт</span>
          <el-checkbox v-model="defaultInputs.fact" size="medium"></el-checkbox>
        </div>
      </div>
      <div class="list-inputs">
        <div class="name-line">
          <span>Примечание</span>
          <el-checkbox v-model="defaultInputs.comment" size="medium"></el-checkbox>
        </div>
      </div>
      <div class="list-inputs">
        <div class="name-line">
          <span>Зона работ</span>
          <el-checkbox v-model="defaultInputs.zone" size="medium"></el-checkbox>
        </div>
      </div>
      <div class="list-inputs">
        <div class="name-line">
          <span>План численность</span>
          <el-checkbox v-model="defaultInputs.plan_population" size="medium"></el-checkbox>
        </div>
      </div>
      <div v-for="input in inputs" class="list-inputs">
        <div class="name-line">
          <span>{{ input.name }}</span>
          <el-checkbox size="medium" v-model="input.checked"></el-checkbox>
        </div>
      </div>
    </div>

    <div class="input-dirs__buttons">
      <el-button @click="$router.go(-1)">Отмена</el-button>
      <el-button type="primary" @click="update()">Сохранить</el-button>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import draggable from 'vuedraggable';
import {getAllInputs} from "../../../firestore/inputs";
import dayjs from "dayjs";

export default {
  name: 'ListDirs',
  components: {draggable},

  data() {
    return {
      defaultInputs: {
        plan: true,
        daily_plan: true,
        fact: true,
        comment: true,
        plan_population: false,
        daily_norm: false,
        zone: false,
      },
      loader: false,
      isCreate: false,
      search: '',
      inputs: [],
      loading: false,
    };
  },

  async mounted() {
    await this.fetchInputs();
    await this.fetchConfig()
  },

  methods: {
    save: _.debounce(function (el, binding) {
      const inputs = this.inputs.map((input, index) => {
        return {
          ...input,
          _data: {
            ...input._data,
            index: index,
          },
        };
      });

      this.update(inputs);
    }, 1000),
    async fetchInputs() {
      this.loader = true;
      const result = []
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inputs')
        .get()
        .then(async (data) => {
          data.forEach((subDoc) => {
            let _data = subDoc.data();
            delete _data.options;
            result.push({
              ..._data,
              checked: false,
              id: subDoc.id
            });
          });

          this.inputs = [..._.orderBy(result, 'index', ['asc'])].filter(({type}) => type)
        })
        .finally(() => {
          this.loader = false;
        })
    },
    async fetchConfig() {
      this.loader = true;
      const result = []
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('show_config')
        .doc(this.$route.params.id === 'all' ? this.$store.state.project.id : this.$route.params.id)
        .get()
        .then(async (data) => {
          const result = data.data()
          if (result) {

            this.defaultInputs = {
              plan: result.plan,
              daily_plan: result.daily_plan,
              fact: result.fact,
              comment: result.comment,
              zone: !!result.zone,
              plan_population: !!result.plan_population,
              daily_norm: !!result.daily_norm
            }

            this.inputs = this.inputs.map((input) => {
              input.checked = !!result[input.id]
              return input
            })
          } else {
            if(this.$route.params.id !== 'all') {
              this.defaultInputs = {
                plan: false,
                daily_plan: false,
                fact: false,
                comment: false,
                zone: false,
                plan_population: false,
                daily_norm: false
              }
            }
          }

        }).finally(() => {

        this.loader = false;
      })
    },
    async update() {
      this.loading = true

      const inputsResult = {}
      this.inputs.forEach((input) => {
        inputsResult[input.id] = !!input.checked
      })

      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('show_config')
        .doc(this.$route.params.id === 'all' ? this.$store.state.project.id : this.$route.params.id )
        .set({
          is_all_flag: this.$route.params.id === 'all',
          ...this.defaultInputs,
          ...inputsResult
        })
        .then(async (data) => {
          this.$notify.success({
            offset: 60,
            title: 'Успешно',
            message: 'Сохранено',
          });

          this.$router.go(-1);
        }).finally(() => {
        this.loader = false;
      })
      this.loading = false
    },
  },
};
</script>

<style lang="scss" scoped>
.input-dirs__buttons {
  z-index: 999;
}

.input-dirs {
  max-width: 420px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &__buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 420px;

    width: 100%;
    position: fixed;
    bottom: 20px;
  }

  .list-inputs {
    padding: 12px 16px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(0, 0, 0, .18);
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
    justify-content: space-between;
  }
}

.required-line {
  display: flex;

  span {
    margin-right: 16px;
    font-size: 13px;
  }
}

.name-line {
  display: flex;
  justify-content: space-between;
  flex: 1;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Inputs/DirsJobsDesktopShow.vue